module.exports = __webpack_public_path__ + "img/properties.0906f821.svg";